/*
 * @Description: 提供cookie的相关信息
 * @Author: fiveonelei
 * @Date: 2022-02-09 10:18:36
 * @FilePath: /vise/packages/app-share/src/composable/use-provide-cookie-info.ts
 */
import { useSSRContext, provide } from 'vue';
import cookie from 'cookie';
import { IS_SSR } from '@/utils/env';

export const PROVIDED_COOKIE_INFO_NAME = 'cookieinfo';

export type Cookieinfo = Record<string, string>;

export default function useProvideCookieInfo() {
  // 获取 cookies
  let info: Cookieinfo = {};
  if (IS_SSR) {
    ({ cookies: info = {} } = useSSRContext() || {});
  } else {
    info = cookie.parse(document.cookie as string || '');
  }
  // provide 信息
  const provideInfo = () => {
    provide(PROVIDED_COOKIE_INFO_NAME, info);
  };

  // 返回相关信息
  return {
    info,
    provideInfo,
  };
};
